// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"0d5fba45","371":"40c9db29","806":"8dd2e6f6"}[chunkId] + ".chunk.js";
};